import { Component, AfterViewInit, OnInit, Inject, ViewChild, ElementRef } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { GestionVendedorService } from "src/app/servicios/gestion-vendedor.service";
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-dialog-detalle-pedido-gml',
  templateUrl: './dialog-detalle-pedido-gml.component.html',
  styleUrls: ['./dialog-detalle-pedido-gml.component.css']
})
export class DialogDetallePedidoGmlComponent implements OnInit {
  @ViewChild('mapContainer') gmap: ElementRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;

  map: google.maps.Map;
  //lat = 4.534791811470397;
  //lng = -75.6730720611766;
  coordinates:any;
  /*mapOptions: google.maps.MapOptions = {
    center: this.coordinates,
    zoom: 16,
  };*/

  marker:any;

  dataCliente:any;
  dataModified=false;


  dtTrigger = new Subject();

  haveData = false;
  timeRunning = 0;

  idEncabezado: any;
  detallePedido = [];
  loadingData = false;
  totalPedido=0;
  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private dialogRef: MatDialog,
    private servicioGestionVendedor: GestionVendedorService
  ) {

    this.loadingData = true;
    this.detallePedido = dataDialog;

    if(this.detallePedido.length>0){
      this.haveData=true;
    }
    this.detallePedido.forEach(element=>{
      this.totalPedido +=element.totalLinea;
    });
    this.dtTrigger.next();
    this.loadingData = false;
  }

  ngOnInit() {}

  ngAfterViewInit() {

  }
}
